import { cn } from '@avanta/shared/utils/cn';
import { type PropsWithChildren, type ReactElement } from 'react';

interface EnrollmentMonthTagProps {
  className?: string;
}

export const EnrollmentMonthTag = ({
  className,
  children,
}: PropsWithChildren<EnrollmentMonthTagProps>): ReactElement => (
  <span
    className={cn(
      'inline-flex w-fit items-center justify-center gap-2 rounded-tl-none rounded-tr rounded-br rounded-bl border-transparent bg-plum-100 px-2 py-1.5 text-center text-sm leading-4 font-medium text-denim-500 capitalize',
      className
    )}
  >
    {children}
  </span>
);
